import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Paper,
} from "@mui/material";
import React from "react";

interface ModalWrapperProps {
  children: React.ReactElement;
  title: string;
  subtitle: string;
  open: boolean;
  customWidth?: number;
  handleClose: () => void;
}

export const ModalWrapper = (props: ModalWrapperProps) => {
  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          p: 3,
          position: "absolute",
          top: { xs: 0, sm: 'auto' },
          bgcolor: "light.light",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: { xs: "100%", sm: "auto" },
          maxWidth: 610,
          borderRadius: { sm: '20px' },
          overflow: 'auto',
        }}
      >
        <IconButton
          aria-label="Fechar modal"
          sx={{
            color: "dark.dark",
            position: "absolute",
            top: 24,
            right: 24,
            display: { xs: "none", md: "block" },
          }}
          onClick={props.handleClose}
        >
          <i
            className="uil uil-times"
            style={{
              fontSize: 24,
            }}
          />
        </IconButton>
        <Box textAlign={"left"}>
          <Typography variant="subtitle1" mb={1}>
            {props.title}
          </Typography>
          <Typography variant="body1" color="dark.light" maxWidth="sm">
            {props.subtitle}
          </Typography>
        </Box>

        <Paper
          variant="outlined"
          sx={{
            mt: 3,
            width: { xs: "100%", md: "auto" },
            border: "none"
          }}
        >
          {props.children}
        </Paper>

        <Button
          variant="contained"
          size="large"
          sx={{
            display: { xs: "flex", md: "none" },
            mt: 3,
          }}
          onClick={props.handleClose}
          startIcon={
            <i
              className="uil uil-arrow-left"
              style={{
                fontSize: 24,
                display: "flex",
              }}
            />
          }
        >
          Voltar
        </Button>
      </Box>
    </Modal>
  );
};
